(function () {
  'use strict';

  var jsonEl = document.querySelector('[data-cc-product-json]');
  if (!jsonEl) return;

  var product = JSON.parse(jsonEl.textContent);

  if (!product.variants || product.variants.length === 0) return;

  var variantMap = {};
  product.variants.forEach(function (v) {
    variantMap[v.title] = v;
  });

  var form = document.querySelector('[data-cc-product-form]');
  if (!form) return;

  var variantInput = form.querySelector('[data-cc-variant-id]');
  var priceEl = document.querySelector('[data-cc-price]');
  var compareEl = document.querySelector('[data-cc-compare-price]');
  var saveEl = document.querySelector('[data-cc-save-chip]');
  var installmentEl = document.querySelector('[data-cc-installment-price]');
  var materialLabel = document.querySelector('[data-cc-material-name]');
  var atcBtn = document.querySelector('[data-cc-atc]');
  var atcText = document.querySelector('[data-cc-atc-text]');
  var expressContainer = document.querySelector('[data-cc-express]');

  // Block-presence detection — gates only apply when the block is rendered
  var hasInitialPicker = !!document.querySelector('[data-cc-initial-picker]');
  // A product may render TWO independent stone groups (birthstone_picker and
  // birthstone_picker_2), each with its own chart, count axis and cart keys.
  // `birthstonePickerEl` stays the FIRST root so every legacy single-group path
  // below is untouched; the per-group model is built further down.
  var birthstoneRoots = [].slice.call(document.querySelectorAll('[data-cc-birthstone-picker]'));
  var birthstonePickerEl = birthstoneRoots[0] || null;
  var hasBirthstonePicker = birthstoneRoots.length > 0;
  var hasUpgradeToggle = !!document.querySelector('[data-cc-upgrade-toggle]');
  var engravingEl = document.querySelector('[data-cc-text-engraving]');
  var hasTextEngraving = !!engravingEl;
  var flowerPickerEl = document.querySelector('[data-cc-birthflower-picker]');
  var hasFlowerPicker = !!flowerPickerEl;

  // Collect the distinct values of a variant option position (1-based),
  // first-seen order. Used by both the numeric-count test and the direct-pick
  // pill axes below.
  function optionValuesAt(pos) {
    var key = 'option' + pos;
    var seen = {};
    var out = [];
    product.variants.forEach(function (v) {
      var val = v[key];
      if (val != null && val !== '' && !seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    });
    return out;
  }

  // ─── Which option position (if any) a personalization block CLAIMS as its
  // count axis, declared in block_config as count_from_variant +
  // variant_option_name. The block reads that option's values for its own count
  // selector; the switcher must therefore NOT also render it as a direct-pick
  // axis, or the customer sees two selectors for one thing (Connected Initials'
  // "Number of Letters" 2/3/4 next to "How many initials?").
  //
  // A declaration only counts when the block that made it is actually rendered —
  // an unrendered block owns nothing, and mis-claiming the axis would let some
  // OTHER picker drive a count ladder it doesn't fit. Any future block that
  // supports count_from_variant must be added to this map.
  var COUNT_BLOCK_SELECTORS = {
    initial_picker: '[data-cc-initial-picker]',
    birthstone_picker: '[data-cc-birthstone-picker]',
    birthstone_picker_2: '[data-cc-birthstone-picker]',
    birthflower_picker: '[data-cc-birthflower-picker]',
    text_engraving: '[data-cc-text-engraving]',
    name_birthstone_picker: '[data-cc-name-birthstone-picker]'
  };

  var blockConfig = null;
  var blockConfigEl = document.querySelector('[data-cc-block-config]');
  if (blockConfigEl) {
    try {
      blockConfig = JSON.parse(blockConfigEl.textContent);
    } catch (err) {
      blockConfig = null;
    }
  }

  // Names of variant options claimed as a count axis by a rendered block.
  var claimedCountOptionNames = [];
  if (blockConfig) {
    Object.keys(blockConfig).forEach(function (key) {
      var cfg = blockConfig[key];
      if (!cfg || !cfg.count_from_variant || !cfg.variant_option_name) return;
      var sel = COUNT_BLOCK_SELECTORS[key];
      if (!sel || !document.querySelector(sel)) return;
      claimedCountOptionNames.push(String(cfg.variant_option_name));
    });
  }

  // ─── Per-group stone axes ────────────────────────────────────────────────
  // Each rendered group names its own count option in block_config
  // (count_from_variant + variant_option_name), matched to the group by
  // data-group-key. Two groups on one product therefore drive TWO different
  // option positions — Live in the Moment is Material / Chain Birthstones /
  // Charm Birthstones — which the single `countAxisIndex` below cannot express.
  function optionIndexByName(name) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      var n = typeof o === 'string' ? o : (o && o.name);
      if (n === name) return i;
    }
    return -1;
  }

  var birthstoneGroups = birthstoneRoots.map(function (root) {
    var key = root.getAttribute('data-group-key') || 'birthstone_picker';
    var cfg = (blockConfig && blockConfig[key]) || {};
    var axisIndex = -1;
    if (cfg.count_from_variant !== false && cfg.variant_option_name) {
      axisIndex = optionIndexByName(String(cfg.variant_option_name));
      if (axisIndex <= 0) axisIndex = -1;   // option1 is Material; never a count
    }
    return {
      root: root,
      key: key,
      cfg: cfg,
      axisIndex: axisIndex,
      label: root.dataset.label || 'Birthstones',
      min: parseInt(root.dataset.minStones, 10) || 1,
      max: parseInt(root.dataset.maxStones, 10) || 5,
      count: 0,
      preview: 0
    };
  });

  // Unpriced-count guard. A group that asks to be driven by a variant axis but
  // whose axis does not exist on the product has every count at the same price,
  // which silently under-charges. Clamp it to `min` and hide its count row —
  // unless the config opts out with allow_unpriced_count, which is how a
  // deliberately FREE count (Birthstone Letter Bracelet) says so.
  birthstoneGroups.forEach(function (g) {
    if (g.axisIndex !== -1) return;
    if (!g.cfg.count_from_variant) return;
    if (g.max <= g.min) return;
    if (g.cfg.allow_unpriced_count === true) return;
    g.clamped = true;
    if (window.console && console.warn) {
      console.warn('[cc-atelier] ' + g.key + '.variant_option_name "' +
        g.cfg.variant_option_name + '" matches no product option; clamping to ' + g.min + '.');
    }
    var btn = g.root.querySelector('[data-cc-count="' + g.min + '"]');
    if (btn && !btn.classList.contains('is-selected')) btn.click();
    // The row is pinned, so showing it would offer a choice that does nothing.
    // This is the ONLY case Atelier hides a stone count row: unlike Pipeline
    // there is no native selector duplicating it, so for a real axis the
    // picker's own row IS the control and must stay visible.
    g.root.setAttribute('data-cc-count-from-variant', '');
  });

  // With two groups the cc:birthstones-changed detail only describes whichever
  // group just moved, so per-group state is read from each root's own slots.
  // Mirrors the picker's locked contract: count is the full N only once EVERY
  // slot holds a stone, and 0 while any is empty.
  function readGroupFromDom(g) {
    var slots = g.root.querySelectorAll('[data-cc-slots] button');
    var filled = 0;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].classList.contains('cc-birthstone-picker__slot--filled')) filled++;
    }
    g.preview = slots.length;
    g.count = (slots.length > 0 && filled === slots.length) ? slots.length : 0;
  }
  function refreshBirthstoneGroups() {
    birthstoneGroups.forEach(readGroupFromDom);
  }

  function optionNameAt(index) {
    var opts = product.options;
    if (!opts || opts[index] == null) return 'Option ' + (index + 1);
    var o = opts[index];
    var name = typeof o === 'string' ? o : (o.name || '');
    return name || 'Option ' + (index + 1);
  }

  // Does this product's 2nd variant option carry a numeric COUNT?
  // Two ways to qualify:
  //  (a) The ladder includes "1" (Sideway 1-5, Garden Bloom 1-5, multi-name,
  //      paired) — the original heuristic, unchanged.
  //  (b) A rendered block explicitly claims option2 by name via
  //      count_from_variant. Connected Initials' ladder is 2/3/4 — no "1" — so
  //      only the declaration can identify it.
  // Numeric-looking SIZE axes (ring sizes 5-12, pendant sizes 3-5mm) include no
  // "1" and are claimed by nobody, so they still fall through to the direct-pick
  // pill axes below. This is what stops bubble-diamond-initial-ring's size from
  // being mis-read as an initial count.
  var option2Values = optionValuesAt(2);
  var option2AllNumeric = option2Values.length > 0 && option2Values.every(function (v) {
    return /^\d+$/.test(v);
  });
  var option2Claimed = option2AllNumeric &&
    claimedCountOptionNames.indexOf(optionNameAt(1)) !== -1;
  var numericOption2 = /^\d+$/.test(product.variants[0].option2 || '') &&
    (option2Values.indexOf('1') !== -1 || option2Claimed);

  // The value the form stays pinned to while a count gate is open. "1" whenever
  // the ladder has it (every pre-existing count product); otherwise the smallest
  // rung that actually exists, so a 2/3/4 ladder pins to "2" instead of a
  // non-existent "1" variant.
  var lowestCountValue = numericOption2
    ? option2Values.slice().sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })[0]
    : '1';
  // Unified numeric-axis rule: the option2 count is claimed by whichever picker
  // is present, in priority order initial -> birthstone -> flower -> engraving,
  // and ONLY when the product actually has a numeric option2. Each *DrivesVariant
  // flag below is gated on numericOption2 for exactly that reason.
  //
  // Initials claim it first (Sideway-style "Gold / 3"), but ONLY when numericOption2
  // is real. On Material-only initial products (3D Heart Initial Bracelet, Custom
  // Letter Sideways Bracelet) initials are personalization, NOT a variant axis:
  // appending a count there builds a "Gold / 3" title that matches no variant and
  // blocks add-to-cart ("CURRENTLY UNAVAILABLE"). When initials don't drive the
  // variant they gate ATC via the property-gate registry (Gate 2) instead.
  var initialDrivesVariant = hasInitialPicker && numericOption2;
  // Stones drive the variant (e.g. Garden Bloom "Gold / 3") when no
  // initial picker is present to claim the numeric axis.
  var birthstoneDrivesVariant = !hasInitialPicker && hasBirthstonePicker && numericOption2;
  // Flowers claim the numeric axis on flower-only products the same way, when
  // neither an initial picker nor a birthstone picker is present to claim it.
  var flowerDrivesVariant = !hasInitialPicker && !hasBirthstonePicker && hasFlowerPicker && numericOption2;
  // Count-first engraving (multi-name) claims the numeric axis last, when no
  // initial/birthstone/flower picker is present to claim it.
  var engravingCountFirst = hasTextEngraving && engravingEl.hasAttribute('data-count-first');
  var engravingDrivesVariant = !hasInitialPicker && !hasBirthstonePicker && !hasFlowerPicker && engravingCountFirst && numericOption2;
  // Name+birthstone paired picker: one count drives N paired (name + stone) rows.
  // It REPLACES the standalone birthstone + text engraving blocks on its products,
  // so none of the flags above are set and it claims the numeric axis cleanly. It
  // is an independent claimant (not folded into the precedence chain above), so
  // adding it never changes when initial/birthstone/flower/engraving drive.
  var nameStonePickerEl = document.querySelector('[data-cc-name-birthstone-picker]');
  var hasNameStonePicker = !!nameStonePickerEl;
  var nameStoneDrivesVariant = hasNameStonePicker && numericOption2;

  // ─── Direct-pick variant axes (Ring Size, Style, Carabiner, Pendant Size…) ──
  // Any variant option position NOT claimed by a numeric-count picker or the
  // Yes/No upgrade toggle is a plain customer-selected axis. Each renders as a
  // pill group; the variant resolves from the chosen value. Purely additive:
  // count-driven (numericOption2) and toggle products keep their exact behavior.
  var countDriver = initialDrivesVariant || birthstoneDrivesVariant ||
    flowerDrivesVariant || engravingDrivesVariant || nameStoneDrivesVariant;

  // Number of option positions on this product (1, 2, or 3).
  var optionCount = 1;
  if (product.variants[0].option2 != null && product.variants[0].option2 !== '') optionCount = 2;
  if (product.variants[0].option3 != null && product.variants[0].option3 !== '') optionCount = 3;

  // The count axis, when present, is always option2. The toggle axis, when
  // present, is always the LAST option (option2 on Material×Diamond, option3 on
  // Material×count×Diamond) — matching how the title has always been assembled.
  var countAxisIndex = countDriver ? 1 : -1;

  // Option position -> the stone group that owns it. Built after optionCount so
  // an axis beyond this product's option count is ignored. When this map is
  // non-empty it takes precedence over the single countAxisIndex below.
  var countAxisMap = {};
  birthstoneGroups.forEach(function (g) {
    if (g.axisIndex > 0 && g.axisIndex < optionCount) countAxisMap[g.axisIndex] = g;
  });
  var hasGroupAxes = Object.keys(countAxisMap).length > 0;
  // With per-group axes the legacy single count axis must stand down, or option2
  // would be written twice (once by the group, once by currentCountValue()).
  if (hasGroupAxes) countAxisIndex = -1;

  // A rendered upgrade toggle only OWNS an axis when the product actually has a
  // Yes/No option to own. On the Sideway 18k shape ("Upgrade with a Diamond?"
  // No/Yes) it does, and everything below behaves exactly as it always has.
  //
  // On a FREE optional add-on (Connected Initials "Add a birthstone?") there is
  // no Yes/No option at all — the stone costs nothing, so no variant exists for
  // it. Claiming a phantom axis there is what produced "Currently Unavailable":
  // the title picked up a "/ No" segment matching no variant. With no Yes/No
  // option present the toggle is a NO-OP on variant resolution — the variant
  // resolves off the real axes (Material + the count) and the toggle acts as a
  // pure line-item property, gated through the property registry instead.
  var toggleAxisIndex = -1;
  if (hasUpgradeToggle) {
    var lastAxisIndex = optionCount - 1;
    var lastAxisValues = optionValuesAt(optionCount);
    var lastAxisIsYesNo = lastAxisValues.length > 0 &&
      lastAxisValues.indexOf('Yes') !== -1 &&
      lastAxisValues.every(function (v) { return v === 'Yes' || v === 'No'; });
    if (lastAxisIsYesNo && lastAxisIndex !== countAxisIndex) {
      toggleAxisIndex = lastAxisIndex;
    }
  }
  // Everything that reads the toggle's value INTO a variant title must key off
  // the axis actually existing, not merely the block being on the page.
  var hasUpgradeToggleAxis = toggleAxisIndex !== -1;

  // Direct-pick axes are NEVER pre-selected on load — the customer must choose
  // explicitly. A pre-picked Ring Size (or Pendant Size, Carabiner…) would ship
  // the wrong item to anyone who skips the selector — the same failure class as
  // a blank personalization. We deliberately do NOT honor a ?variant=<id> deep
  // link here either: collection/"featured variant" links, Shopify's default-
  // variant URL, and a prior tap's history.replaceState all drop a ?variant into
  // the address bar without the customer consciously choosing a size, so seeding
  // from it would silently re-introduce the exact pre-selection we're removing.
  // Always start null; the size only becomes selected on an explicit tap.
  var directAxes = [];
  for (var oi = 1; oi < optionCount; oi++) {
    if (oi === countAxisIndex || oi === toggleAxisIndex) continue;
    if (countAxisMap[oi]) continue;   // owned by a stone group's count row
    directAxes.push({
      index: oi,
      name: optionNameAt(oi),
      values: optionValuesAt(oi + 1),
      selected: null
    });
  }
  var hasDirectAxes = directAxes.length > 0;

  // Gate 2 registry — generic required line-item-property gates. Any block
  // whose "changed" event carries {label, filled, min, required} plugs in
  // here; no further switcher changes needed for future required blocks.
  var propertyGates = {};

  // Pre-seed from the DOM so the ATC gates correctly before first events.
  // Material-only initial products: initials are required personalization but not
  // a variant axis, so enforce "must enter initials" via the registry (Gate 2)
  // rather than the numeric-axis gate (Gate 1). filled updates on cc:initials-changed.
  if (hasInitialPicker && !initialDrivesVariant) {
    propertyGates.initials = {
      label: 'Initials',
      filled: 0,
      min: 1,
      required: true
    };
  }
  if (hasBirthstonePicker && !birthstoneDrivesVariant) {
    // Conditional ("Add a birthstone?") mode is OPTIONAL: a stone is required
    // only while the toggle sits on Yes, so the pre-seed must mirror the toggle's
    // default rather than the count-mode "at least one" rule. Seeding min 1 under
    // a default of No would disable ATC for anyone who never touches the toggle.
    // The picker's init event overwrites this either way; seeding it correctly
    // keeps ATC right even if script order ever changes.
    var bsConditional = birthstonePickerEl.hasAttribute('data-cc-conditional');
    var bsMin;
    if (bsConditional) {
      bsMin = birthstonePickerEl.dataset.toggleDefault === 'true' ? 1 : 0;
    } else {
      bsMin = parseInt(birthstonePickerEl.dataset.minStones, 10) || 1;
    }
    propertyGates.birthstones = {
      label: birthstonePickerEl.dataset.label || 'Birthstones',
      filled: 0,
      min: bsMin,
      required: true
    };
  }
  if (hasTextEngraving && engravingEl.hasAttribute('data-required') && !engravingDrivesVariant) {
    propertyGates[engravingEl.dataset.property || 'engraving'] = {
      label: engravingEl.dataset.label || 'Engraving',
      filled: 0,
      min: engravingEl.hasAttribute('data-multi')
        ? (parseInt(engravingEl.dataset.minSlots, 10) || 1)
        : 1,
      required: true
    };
  }
  document.querySelectorAll('[data-cc-toggle][data-required]').forEach(function (el) {
    propertyGates[el.dataset.property || 'toggle'] = {
      label: el.dataset.label || 'Option',
      filled: el.hasAttribute('data-default-on') ? 1 : 0,
      min: 1,
      required: true
    };
  });
  var dateFieldEl = document.querySelector('[data-cc-date-field]');
  if (dateFieldEl && dateFieldEl.hasAttribute('data-required')) {
    propertyGates[dateFieldEl.dataset.property || 'date'] = {
      label: dateFieldEl.dataset.label || 'Date',
      filled: 0,
      min: 1,
      required: true
    };
  }
  var photoUploadEl = document.querySelector('[data-cc-photo-upload]');
  if (photoUploadEl && photoUploadEl.hasAttribute('data-required')) {
    propertyGates[photoUploadEl.dataset.property || 'photo'] = {
      label: photoUploadEl.dataset.label || 'Photo',
      filled: 0,
      min: 1,
      required: true
    };
  }
  var designerNotesEl = document.querySelector('[data-cc-designer-notes]');
  if (designerNotesEl && designerNotesEl.hasAttribute('data-required')) {
    propertyGates[designerNotesEl.dataset.property || 'notes'] = {
      label: designerNotesEl.dataset.label || 'Notes',
      filled: 0,
      min: 1,
      required: true
    };
  }
  var customDropdownEl = document.querySelector('[data-cc-custom-dropdown]');
  if (customDropdownEl && customDropdownEl.hasAttribute('data-required')) {
    propertyGates[customDropdownEl.dataset.property || 'dropdown'] = {
      label: customDropdownEl.dataset.label || 'Option',
      filled: customDropdownEl.querySelector('[data-cc-dropdown-option].is-selected') ? 1 : 0,
      min: 1,
      required: true
    };
  }
  var numberFieldEl = document.querySelector('[data-cc-number-field]');
  if (numberFieldEl && numberFieldEl.hasAttribute('data-required')) {
    var nfInput = numberFieldEl.querySelector('[data-cc-number-input]');
    var nfMin = parseFloat(numberFieldEl.dataset.min);
    var nfMax = parseFloat(numberFieldEl.dataset.max);
    var nfVal = nfInput ? parseFloat(nfInput.value) : NaN;
    var nfValid = !isNaN(nfVal) &&
      (isNaN(nfMin) || nfVal >= nfMin) &&
      (isNaN(nfMax) || nfVal <= nfMax);
    propertyGates[numberFieldEl.dataset.property || 'number'] = {
      label: numberFieldEl.dataset.label || 'Quantity',
      filled: nfValid ? 1 : 0,
      min: 1,
      required: true
    };
  }
  // Property-mode flowers (not driving the variant axis) gate ATC via the
  // registry, exactly like property-mode birthstones.
  if (hasFlowerPicker && !flowerDrivesVariant) {
    propertyGates[flowerPickerEl.dataset.property || 'Birthflowers'] = {
      label: flowerPickerEl.dataset.label || 'Birth flower',
      filled: 0,
      min: parseInt(flowerPickerEl.dataset.minFlowers, 10) || 1,
      required: true
    };
  }
  document.querySelectorAll('[data-cc-text-field][data-required]').forEach(function (el) {
    var tfInput = el.querySelector('[data-cc-text-field-input]');
    propertyGates['textfield:' + (el.dataset.property || el.dataset.label || '')] = {
      label: el.dataset.label || 'Engraving',
      filled: (tfInput && String(tfInput.value).trim() !== '') ? 1 : 0,
      min: 1,
      required: true
    };
  });

  // Zodiac picker — single-select, never a variant axis; a pure required-property
  // gate like date/photo/dropdown. Pre-seed from the DOM so ATC gates correctly
  // before the first cc:zodiac-changed event.
  var zodiacPickerEl = document.querySelector('[data-cc-zodiac-picker]');
  if (zodiacPickerEl && zodiacPickerEl.hasAttribute('data-required')) {
    propertyGates[zodiacPickerEl.dataset.property || 'Zodiac'] = {
      label: zodiacPickerEl.dataset.label || 'Zodiac',
      filled: 0,
      min: 1,
      required: true
    };
  }

  // Multi-group products register ONE gate per group, so a complete chain group
  // can never satisfy the gate on an empty charm group. Single-group products
  // keep the legacy `propertyGates.birthstones` entry above untouched.
  if (birthstoneGroups.length > 1) {
    birthstoneGroups.forEach(function (g) {
      if (g.axisIndex !== -1) return;
      propertyGates['birthstones:' + g.key] = {
        label: g.label,
        filled: 0,
        min: g.min,
        required: true
      };
    });
  }

  // Filled vs total across whichever picker is still incomplete, read straight
  // from the DOM. Same generic pattern as readGroupFromDom above and the sticky
  // bar's nextStep: any block that renders a [data-cc-slots] row exposes its
  // progress as filled vs total slot buttons, so this works for birthstone,
  // initial and name pickers without knowing which is on the page, and the
  // numbers always come from the product's real configuration.
  function slotProgress() {
    var rows = document.querySelectorAll('#cc-product-form [data-cc-slots]');
    for (var i = 0; i < rows.length; i++) {
      var slots = rows[i].querySelectorAll('button');
      if (!slots.length) continue;
      var filled = 0;
      for (var j = 0; j < slots.length; j++) {
        if (slots[j].className.indexOf('--filled') > -1) filled++;
      }
      if (filled < slots.length) return { filled: filled, total: slots.length };
    }
    return null;
  }

  // Three states for the button, one place.
  //
  //   nothing chosen   -> the merchant's own label, untouched
  //   partly chosen    -> "1 OF 3 CHOSEN"
  //   complete         -> handled by the caller ("ADD TO CART . $84.99")
  //
  // The middle state carries no noun on purpose. The label in block_config is
  // singular on most products ("Birthstone"), so building a phrase from it means
  // inventing a plural per product. A count needs no grammar.
  function gateLabel(fallback) {
    var p = slotProgress();
    if (!p || p.filled === 0) return fallback;
    return p.filled + ' OF ' + p.total + ' CHOSEN';
  }

  function failingPropertyGate() {
    var keys = Object.keys(propertyGates);
    for (var i = 0; i < keys.length; i++) {
      var g = propertyGates[keys[i]];
      if (g.required && g.filled < g.min) return g;
    }
    return null;
  }

  var state = {
    material: product.variants[0].option1 || '',
    initialCount: 0,
    initialPreview: 0,
    diamond: 'No',
    birthstoneCount: 0,
    birthstonePreview: 0,
    birthstoneMin: hasBirthstonePicker ? (parseInt(birthstonePickerEl.dataset.minStones, 10) || 1) : 0,
    birthstoneLabel: hasBirthstonePicker ? (birthstonePickerEl.dataset.label || 'Birthstones') : 'Birthstones',
    flowerCount: 0,
    flowerPreview: 0,
    flowerMin: hasFlowerPicker ? (parseInt(flowerPickerEl.dataset.minFlowers, 10) || 1) : 0,
    flowerLabel: hasFlowerPicker ? (flowerPickerEl.dataset.label || 'Birth flower') : 'Birth flower',
    engravingCount: 0,
    engravingPreview: 0,
    engravingLabel: hasTextEngraving ? (engravingEl.dataset.label || 'Engraving') : 'Engraving',
    nameStoneCount: 0,
    nameStonePreview: 0,
    nameStoneLabel: hasNameStonePicker ? (nameStonePickerEl.dataset.label || 'Names') : 'Names'
  };

  var urlVariantId = new URLSearchParams(window.location.search).get('variant');
  if (urlVariantId) {
    var match = product.variants.find(function (v) {
      return String(v.id) === urlVariantId;
    });
    if (match) {
      state.material = match.option1 || state.material;
      state.initialCount = parseInt(match.option2, 10) || 0;
      state.diamond = match.option3 || 'No';
    }
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    var dollars = cents / 100;
    return dollars % 1 === 0 ? '$' + dollars : '$' + dollars.toFixed(2);
  }

  function updatePriceDisplay(variant) {
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (compareEl) {
      compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      compareEl.hidden = !hasCompare;
    }

    if (saveEl) {
      if (hasCompare) {
        saveEl.textContent = 'SAVE ' + formatMoney(variant.compare_at_price - variant.price);
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    if (installmentEl) {
      installmentEl.textContent = formatMoney(Math.round(variant.price / 4));
    }

    if (materialLabel) materialLabel.textContent = state.material;
  }

  function setMaterialSwatchUI() {
    document.querySelectorAll('[data-cc-material]').forEach(function (btn) {
      var isSelected = btn.dataset.ccMaterial === state.material;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Build a pill group per direct-pick axis and wire selection. Reuses the
  // material label + custom-dropdown pill styles (no new CSS).
  function renderDirectAxes() {
    var container = document.querySelector('[data-cc-axis-selectors]');
    if (!container || !hasDirectAxes) return;

    var html = '';
    directAxes.forEach(function (axis) {
      html += '<div class="cc-pdp__material" data-cc-axis-group data-axis-index="' + axis.index + '">';
      html += '<p class="cc-pdp__material-label">' + escapeHtml(axis.name) +
        ' / <strong data-cc-axis-value="' + axis.index + '">' +
        escapeHtml(axis.selected != null ? axis.selected : 'Select') + '</strong></p>';
      html += '<div class="cc-custom-dropdown__pills" role="radiogroup" aria-label="' + escapeHtml(axis.name) + '">';
      axis.values.forEach(function (val) {
        var sel = val === axis.selected;
        html += '<button type="button" class="cc-custom-dropdown__pill' + (sel ? ' is-selected' : '') + '"' +
          ' data-cc-axis-pill data-axis-index="' + axis.index + '" data-value="' + escapeHtml(val) + '"' +
          ' role="radio" aria-checked="' + (sel ? 'true' : 'false') + '" aria-label="' + escapeHtml(val) + '">' +
          escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
    });
    container.innerHTML = html;

    container.querySelectorAll('[data-cc-axis-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.axisIndex, 10);
        var axis = directAxes.find(function (a) { return a.index === idx; });
        if (!axis) return;
        axis.selected = this.dataset.value;
        updateVariant();
      });
    });
  }

  function setDirectAxisUI() {
    directAxes.forEach(function (axis) {
      document.querySelectorAll('[data-cc-axis-pill][data-axis-index="' + axis.index + '"]').forEach(function (btn) {
        var sel = btn.dataset.value === axis.selected;
        btn.classList.toggle('is-selected', sel);
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
      });
      var label = document.querySelector('[data-cc-axis-value="' + axis.index + '"]');
      if (label) label.textContent = axis.selected != null ? axis.selected : 'Select';
    });
  }

  function currentCountValue() {
    if (initialDrivesVariant) return state.initialCount;
    if (birthstoneDrivesVariant) return state.birthstoneCount;
    if (flowerDrivesVariant) return state.flowerCount;
    if (engravingDrivesVariant) return state.engravingCount;
    if (nameStoneDrivesVariant) return state.nameStoneCount;
    return null;
  }

  function directAxisValue(index) {
    for (var i = 0; i < directAxes.length; i++) {
      if (directAxes[i].index === index) return directAxes[i].selected;
    }
    return '';
  }

  function firstUnselectedDirectAxis() {
    for (var i = 0; i < directAxes.length; i++) {
      if (directAxes[i].selected == null) return directAxes[i];
    }
    return null;
  }

  // Position-aware title: walk each option slot and pull its value from the
  // owning mechanism — material (option1), the count picker (option2 when a
  // picker drives it), the Yes/No toggle (last option), or a direct-pick axis.
  // For count-only / toggle-only / single-axis products this yields the exact
  // same string the old fixed assembly did.
  function buildTitle() {
    var parts = [];
    for (var i = 0; i < optionCount; i++) {
      if (i === 0) {
        parts.push(state.material);
      } else if (countAxisMap[i]) {
        parts.push(String(countAxisMap[i].count));
      } else if (i === countAxisIndex) {
        parts.push(String(currentCountValue()));
      } else if (i === toggleAxisIndex) {
        parts.push(state.diamond);
      } else {
        parts.push(directAxisValue(i));
      }
    }
    return parts.join(' / ');
  }

  function updateVariant() {
    // Gate 1 — the numeric variant axis is incomplete:
    // initials on Sideway-style products, stones on Garden Bloom-style.
    var gateText = null;

    // Gate 1a — per-group stone axes. EVERY group that owns an axis must be
    // complete before a variant can commit, so a finished chain group cannot
    // carry an unfinished charm group past add-to-cart.
    var failingGroup = null;
    if (hasGroupAxes) {
      for (var gi = 0; gi < birthstoneGroups.length; gi++) {
        var gCheck = birthstoneGroups[gi];
        if (gCheck.axisIndex === -1) continue;
        if (gCheck.count < gCheck.min) { failingGroup = gCheck; break; }
      }
      if (failingGroup) {
        gateText = gateLabel('CHOOSE YOUR ' + failingGroup.label.toUpperCase());
      }
    }

    if (gateText) {
      // handled by the per-group branch immediately below
    } else if (initialDrivesVariant && state.initialCount < 1) {
      // Price preview is decoupled from the gate: once a number is picked
      // (initialPreview >= 1) we show that variant's price, but ATC stays
      // disabled until every box is filled (initialCount becomes N).
      gateText = gateLabel('CHOOSE YOUR INITIALS');
    } else if (birthstoneDrivesVariant && state.birthstoneCount < state.birthstoneMin) {
      // Same decoupling as initials: once a number is picked (birthstonePreview
      // >= 1) we show that variant's price, but ATC stays disabled until every
      // slot holds a month (birthstoneCount becomes N).
      gateText = gateLabel('CHOOSE YOUR ' + state.birthstoneLabel.toUpperCase());
    } else if (flowerDrivesVariant && state.flowerCount < state.flowerMin) {
      // Flower-count axis, same decoupling as birthstones.
      gateText = gateLabel('CHOOSE YOUR ' + state.flowerLabel.toUpperCase());
    } else if (engravingDrivesVariant && state.engravingCount < 1) {
      // Multi-name count axis. engravingCount stays 0 until every box is
      // filled (all-N-required), so ATC gates the same way — and the in-block
      // "Enter all N names to continue" message shows alongside.
      gateText = gateLabel('CHOOSE YOUR ' + state.engravingLabel.toUpperCase());
    } else if (nameStoneDrivesVariant && state.nameStoneCount < 1) {
      // Paired name+stone count axis. nameStoneCount stays 0 until every row has
      // both a name and a stone (all-N-required), so ATC gates the same way — the
      // in-block "Enter all N names and their birthstones" message shows alongside.
      gateText = gateLabel('CHOOSE YOUR ' + state.nameStoneLabel.toUpperCase());
    }

    if (gateText && hasGroupAxes) {
      // Price preview across BOTH axes: each group contributes its own option
      // position, using the count it has picked and its minimum otherwise. The
      // previewed variant is therefore the one that will commit once every slot
      // is filled. It is pinned on the form but uncommittable — ATC and express
      // checkout are disabled right below.
      var gParts = [];
      for (var pi = 0; pi < optionCount; pi++) {
        if (pi === 0) {
          gParts.push(state.material);
        } else if (countAxisMap[pi]) {
          var pg = countAxisMap[pi];
          gParts.push(String(pg.preview >= 1 ? pg.preview : pg.min));
        } else if (pi === toggleAxisIndex) {
          gParts.push(state.diamond);
        } else {
          gParts.push(directAxisValue(pi));
        }
      }
      var gVariant = variantMap[gParts.join(' / ')];
      if (gVariant) {
        updatePriceDisplay(gVariant);
        variantInput.value = gVariant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = gateText;
      if (expressContainer) expressContainer.style.opacity = '0.4';
      if (expressContainer) expressContainer.style.pointerEvents = 'none';
      setMaterialSwatchUI();
      setDirectAxisUI();
      return;
    }

    if (gateText) {
      // The count=1 fallback is what the form's variant stays pinned to while
      // gated — unchanged from before this edit, and uncommittable because ATC
      // + express checkout are disabled below.
      var fallback = product.variants.find(function (v) {
        return v.option1 === state.material
          && (!numericOption2 || v.option2 === lowestCountValue)
          && (!hasUpgradeToggleAxis || v.option3 === state.diamond);
      });

      // Price PREVIEW only: when a number is picked, display the price of the
      // Material / N / [diamond] variant (resolved via the same variantMap key
      // a complete selection would use, so the previewed price equals the price
      // that will commit once all boxes are filled). Never assigned to the form.
      var priceVariant = fallback;
      if (initialDrivesVariant && state.initialPreview >= 1) {
        var previewParts = [state.material, String(state.initialPreview)];
        if (hasUpgradeToggleAxis) previewParts.push(state.diamond);
        priceVariant = variantMap[previewParts.join(' / ')] || fallback;
      } else if (birthstoneDrivesVariant && state.birthstonePreview >= 1) {
        var bsPreviewParts = [state.material, String(state.birthstonePreview)];
        if (hasUpgradeToggleAxis) bsPreviewParts.push(state.diamond);
        priceVariant = variantMap[bsPreviewParts.join(' / ')] || fallback;
      } else if (flowerDrivesVariant && state.flowerPreview >= 1) {
        var flPreviewParts = [state.material, String(state.flowerPreview)];
        if (hasUpgradeToggleAxis) flPreviewParts.push(state.diamond);
        priceVariant = variantMap[flPreviewParts.join(' / ')] || fallback;
      } else if (engravingDrivesVariant && state.engravingPreview >= 1) {
        var enPreviewParts = [state.material, String(state.engravingPreview)];
        if (hasUpgradeToggleAxis) enPreviewParts.push(state.diamond);
        priceVariant = variantMap[enPreviewParts.join(' / ')] || fallback;
      } else if (nameStoneDrivesVariant && state.nameStonePreview >= 1) {
        var nsPreviewParts = [state.material, String(state.nameStonePreview)];
        if (hasUpgradeToggleAxis) nsPreviewParts.push(state.diamond);
        priceVariant = variantMap[nsPreviewParts.join(' / ')] || fallback;
      }

      if (priceVariant) updatePriceDisplay(priceVariant);
      if (fallback) {
        variantInput.value = fallback.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = gateText;
      if (expressContainer) expressContainer.style.opacity = '0.4';
      if (expressContainer) expressContainer.style.pointerEvents = 'none';
      setMaterialSwatchUI();
      setDirectAxisUI();
      return;
    }

    // Gate 1b — direct-pick axes (Ring Size, Pendant Size, Carabiner…) are never
    // pre-selected: block ATC until the customer explicitly picks every one, so
    // nobody buys a default they never chose. Show a representative current-
    // material price so the PDP isn't blank, but never commit a variant here.
    var unpicked = firstUnselectedDirectAxis();
    if (unpicked) {
      var matVariant = product.variants.find(function (v) { return v.option1 === state.material; });
      if (matVariant) updatePriceDisplay(matVariant);
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'CHOOSE YOUR ' + unpicked.name.toUpperCase();
      if (expressContainer) expressContainer.style.opacity = '0.4';
      if (expressContainer) expressContainer.style.pointerEvents = 'none';
      setMaterialSwatchUI();
      setDirectAxisUI();
      return;
    }

    // Position-aware title: material / [count axis] / [toggle axis] with any
    // direct-pick axes (size, style, carabiner…) slotted in their own positions.
    var title = buildTitle();
    var variant = variantMap[title];

    if (!variant) {
      console.error('CC Variant Switcher: no variant for "' + title + '"');
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'CURRENTLY UNAVAILABLE';
      return;
    }

    variantInput.value = variant.id;
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));

    updatePriceDisplay(variant);

    history.replaceState(null, '', '?variant=' + variant.id);

    if (variant.available) {
      // Gate 2 (generic) — required line-item property blocks: property-mode
      // birthstones, required engraving, any future registered block.
      // Price still displays: properties never change the variant.
      var failingGate = failingPropertyGate();
      if (failingGate) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = gateLabel('ADD ' + failingGate.label.toUpperCase() + ' TO CONTINUE');
        if (expressContainer) expressContainer.style.opacity = '0.4';
        if (expressContainer) expressContainer.style.pointerEvents = 'none';
      } else {
        if (atcBtn) atcBtn.disabled = false;
        // Price on the button itself. priceEl has already been written for this
        // variant further up in updateVariant, so this is the committed price,
        // and the sticky bar mirrors [data-cc-atc-text] so it gets this free.
        if (atcText) {
          var shownPrice = priceEl ? priceEl.textContent.trim() : '';
          atcText.textContent = shownPrice ? 'ADD TO CART \u00b7 ' + shownPrice : 'ADD TO CART';
        }
        if (expressContainer) expressContainer.style.opacity = '';
        if (expressContainer) expressContainer.style.pointerEvents = '';
      }
    } else {
      if (atcBtn) atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'CURRENTLY UNAVAILABLE';
      if (expressContainer) expressContainer.style.opacity = '0.4';
      if (expressContainer) expressContainer.style.pointerEvents = 'none';
    }

    setMaterialSwatchUI();
    setDirectAxisUI();
  }

  document.querySelectorAll('[data-cc-material]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.material = this.dataset.ccMaterial;
      updateVariant();
    });
  });

  document.addEventListener('cc:initials-changed', function (e) {
    state.initialCount = e.detail.count;                 // gates ATC / commits variant
    state.initialPreview = e.detail.selectedCount || 0;  // price preview only
    if (propertyGates.initials) {
      // Material-only products: initials gate ATC as a required property, not a
      // variant axis. detail.count is N only once every box is filled, 0 otherwise.
      propertyGates.initials.filled = e.detail.count;
    }
    updateVariant();
  });

  document.addEventListener('cc:diamond-changed', function (e) {
    state.diamond = e.detail.value;
    updateVariant();
  });

  document.addEventListener('cc:birthstones-changed', function (e) {
    // Re-read every group from the DOM: the detail describes only the group that
    // just changed, which is not enough once a product has two.
    refreshBirthstoneGroups();
    if (birthstoneGroups.length > 1) {
      birthstoneGroups.forEach(function (g) {
        if (g.axisIndex !== -1) return;
        propertyGates['birthstones:' + g.key] = {
          label: g.label,
          filled: g.count,
          min: g.min,
          required: true
        };
      });
    }
    state.birthstoneCount = e.detail.count;                  // gates ATC / commits variant
    state.birthstonePreview = e.detail.selectedCount || 0;   // price preview only
    state.birthstoneMin = e.detail.min;
    state.birthstoneLabel = e.detail.label;
    if (!birthstoneDrivesVariant && birthstoneGroups.length === 1) {
      propertyGates.birthstones = {
        label: e.detail.label,
        filled: e.detail.count,
        min: e.detail.min,
        required: true
      };
    }
    updateVariant();
  });

  document.addEventListener('cc:birthflowers-changed', function (e) {
    state.flowerCount = e.detail.count;                       // gates ATC / commits variant
    state.flowerPreview = e.detail.selectedCount || 0;        // price preview only
    state.flowerMin = e.detail.min;
    state.flowerLabel = e.detail.label;
    if (!flowerDrivesVariant) {
      propertyGates[e.detail.property] = {
        label: e.detail.label,
        filled: e.detail.count,
        min: e.detail.min,
        required: true
      };
    }
    updateVariant();
  });

  document.addEventListener('cc:engraving-changed', function (e) {
    if (engravingDrivesVariant) {
      // Count-first multi-name drives the variant axis (not a property gate):
      // count gates ATC + commits the variant, selectedCount previews price.
      state.engravingCount = e.detail.count || 0;
      state.engravingPreview = e.detail.selectedCount || 0;
    } else {
      // Single / add-another engraving: unchanged property-gate behavior.
      propertyGates[e.detail.property] = {
        label: e.detail.label,
        filled: e.detail.filled,
        min: e.detail.min,
        required: e.detail.required
      };
    }
    updateVariant();
  });

  document.addEventListener('cc:name-birthstone-changed', function (e) {
    if (nameStoneDrivesVariant) {
      // Count-first paired name+stone drives the variant axis (not a property gate):
      // count (0 until every row has a name AND a stone) gates ATC + commits the
      // variant; selectedCount previews price.
      state.nameStoneCount = e.detail.count || 0;
      state.nameStonePreview = e.detail.selectedCount || 0;
    } else {
      // Fixed / no numeric axis: gate as a required line-item property instead.
      propertyGates[e.detail.property] = {
        label: e.detail.label,
        filled: e.detail.filled,
        min: e.detail.min,
        required: e.detail.required
      };
    }
    updateVariant();
  });

  document.addEventListener('cc:toggle-changed', function (e) {
    if (!e.detail.required) return;
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.on ? 1 : 0,
      min: 1,
      required: true
    };
    updateVariant();
  });

  document.addEventListener('cc:date-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  document.addEventListener('cc:photo-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  document.addEventListener('cc:notes-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  document.addEventListener('cc:dropdown-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  document.addEventListener('cc:number-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  // One aggregated event for the whole text_fields block; re-register a gate per
  // required entry so a filled first field can't satisfy an empty second one.
  document.addEventListener('cc:textfields-changed', function (e) {
    var tfFields = (e.detail && e.detail.fields) || [];
    tfFields.forEach(function (f) {
      if (!f.required) return;
      propertyGates['textfield:' + (f.property || f.label || '')] = {
        label: f.label || 'Engraving',
        filled: f.filled,
        min: 1,
        required: true
      };
    });
    updateVariant();
  });

  document.addEventListener('cc:zodiac-changed', function (e) {
    propertyGates[e.detail.property] = {
      label: e.detail.label,
      filled: e.detail.filled,
      min: e.detail.min,
      required: e.detail.required
    };
    updateVariant();
  });

  renderDirectAxes();
  setMaterialSwatchUI();
  // The pickers emit their first event before this script runs (script order),
  // so seed group state from the DOM rather than waiting for an event that has
  // already fired.
  refreshBirthstoneGroups();
  updateVariant();
})();
